import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiKeyHeader } from "../../../../configs/ApiKeys";
export const fetchPeriods = createAsyncThunk(
  "myTimetable/fetchPeriods",
  async (_, thunkAPI) => {
    try {
      const response = await axios.get(
        "https://web1024.docmaster.in:5010/api/periods/1",
        {
          headers: apiKeyHeader()
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchTeacherTimetable = createAsyncThunk(
  "teacherTimetable/fetch",
  async (teacherId, thunkAPI) => {
    try {
      const res = await axios.get(
        `https://web1024.docmaster.in:5010/api/teachers/${teacherId}/1`,
         {
          headers: apiKeyHeader()
        }
      );
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const myTimetableSlice = createSlice({
  name: "myTimetable",
  initialState: {
    periods: [],
    teacherPeriods: [],
    loading: false,
    error: null,
    
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPeriods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPeriods.fulfilled, (state, action) => {
        state.loading = false;
        state.periods = action.payload;
      })
      .addCase(fetchPeriods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTeacherTimetable.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherTimetable.fulfilled, (state, action) => {
        state.loading = false;
        state.teacherPeriods = action.payload;
      })
      .addCase(fetchTeacherTimetable.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default myTimetableSlice.reducer;
